import axios from "axios";

const options = {
  token: "",
  // tenantId: '',
  parentId: "1678656149325549570",
  tenantId: "1647152297899204609",
  backUrl: "123",
  userId: "1647157865565134849", // 非必传
  path: "",
  bucketName: "1678655958080851969-img",
  accessSecret: "homrwc6y9ew7qxkyukdznk35a0hquq",
  accessKey: "JXY1rjcr68i8lcz6fghojqf5",
};

/**
 * 根据文件的md5获取未上传完的任务
 * @param identifier 文件md5
 * @returns {Promise<AxiosResponse<any>>}
 */
export const taskInfo = (identifier) => {
  console.log(process.env.VUE_APP_API_TSP_IMGUPLOAD,'process.env.VUE_APP_API_TSP_IMGUPLOAD');
  
  return axios.get(`${process.env.VUE_APP_API_TSP_IMGUPLOAD}/resmanage/sdk/${identifier}`, { headers: { accessKey: options.accessKey, accessSecret: options.accessSecret } });
};

/**
 * 初始化一个分片上传任务
 * @param identifier 文件md5
 * @param fileName 文件名称
 * @param totalSize 文件大小
 * @param chunkSize 分块大小
 * @returns {Promise<AxiosResponse<any>>}
 */
export const initTask = ({ identifier, fileName, totalSize, chunkSize }, apiOptions) => {
  return axios.post(
    `${process.env.VUE_APP_API_TSP_IMGUPLOAD}/resmanage/sdk`,
    {
      tenantId: options.tenantId,
      userId: options.userId,
      parentId: options.parentId,
      path: apiOptions.path ? apiOptions.path : options.path,
      bucketName: apiOptions.bucketName ? apiOptions.bucketName : options.bucketName,
      identifier,
      fileName,
      totalSize,
      chunkSize,
      backUrl: options.backUrl,
    },
    { headers: { accessKey: options.accessKey, accessSecret: options.accessSecret } }
  );
};

/**
 * 合并分片
 * @param identifier
 * @returns {}
 */
export const merge = (identifier) => {
  return axios.post(`${process.env.VUE_APP_API_TSP_IMGUPLOAD}/resmanage/sdk/merge/${identifier}`, {}, { headers: { accessKey: options.accessKey, accessSecret: options.accessSecret } });
};

/**
 * 获取预签名分片上传地址
 * @param identifier 文件md5
 * @param partNumber 分片编号
 * @returns {}
 */
export const preSignUrl = ({ identifier, partNumber }) => {
  return axios.get(`${process.env.VUE_APP_API_TSP_IMGUPLOAD}/resmanage/sdk/${identifier}/${partNumber}`, { headers: { accessKey: options.accessKey, accessSecret: options.accessSecret } });
};
